// extracted by mini-css-extract-plugin
export default {"root":"Fees_root__q6Kqu","lastUpdated":"Fees_lastUpdated__RTqgl marketplaceBodyFontStyles","scopedList":"Fees_scopedList__D8WWS"};